<template>
  <div class="p-8" v-if="loading">
    <loading />
  </div>
  <div class="h-full grid grid-rows-1-auto" v-else>
    <div v-if="targetNewFriends && targetNewFriends.length > 0">
      <friend
        v-for="friend in targetNewFriends"
        :key="friend.id"
        :friend="friend"
        :checkbox="true"
        @input="storeFriend"
      />
    </div>
    <div class="text-right p-4">
      <wd-button
        @input="sendInvites"
        :disabled="noneSelected"
        :sending="sending"
        >{{ $t("general.send") }}</wd-button
      >
    </div>
  </div>
</template>

<script>
import FormMixin from "@/mixins/FormMixin";

const Friend = require("@/modules/users/components/Friend.vue").default;

export default {
  name: "TargetAddFriends",
  mixins: [FormMixin],
  data() {
    return {
      target: null,
      targetInvitations: null,
      noneSelected: true,
    };
  },
  props: {
    id: {
      default: null,
      type: String,
    },
  },
  components: {
    Friend,
  },
  methods: {
    sendInvites() {
      this.submit(this.formOptions);
    },
    storeFriend(Input) {
      if (Input.checked) {
        if (this.formData.friends.indexOf(Input.friend.id) === -1) {
          this.formData.friends.push(Input.friend.id);
        }
      } else {
        this.formData.friends.splice(
          this.formData.friends.findIndex((e) => e !== Input.friend.id),
          1
        );
      }
      this.noneSelected = this.formData.friends.length < 1;
    },
  },
  computed: {
    friends() {
      let userFriends = this.$store.getters["userfriend/userFriends"];
      return userFriends ? userFriends.map((e) => e.friend) : false;
    },
    targetNewFriends() {
      let targetFriends = this.target.target_members.map((e) => e.user_id);
      let ownId = this.$store.getters["auth/ownId"];
      return this.friends.filter(
        (e) =>
          !targetFriends.includes(e.id) &&
          !this.targetInvitations.map((e) => e.user_id).includes(e.id) &&
          e.id !== ownId
      );
    },
  },
  async created() {
    await this.$store.getters["userfriend/api"].Custom.My();
    this.target = await this.$store.getters["target/api"].Show(this.id);
    this.targetInvitations = await this.$store.getters[
      "target/api"
    ].Custom.Invitations(this.target.id);

    this.formData.friends = [];

    this.formOptions = {
      custom: true,
      async: true,
      type: "targetinvitation",
      call: "invite",
      id: this.id,
      action: (response) => {
        this.popup({
          type: "success",
          title: this.$t("targets.edit.invitations_sent"),
          autoHide: true,
        });
        this.$router.go(-1);
      },
    };

    this.$store.dispatch("header/update", {
      backbutton: true,
      clear: true,
      elements: [
        {
          value: this.$t("targets.invitation.invite_friend"),
        },
      ],
    });
    this.loaded();
  },
};
</script>
